export default function Apropos() {
  return (
    <section className="bg-base text-textMain min-h-screen py-20 px-6">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-4xl font-serif mb-10 text-center">About</h2>
        <p className="text-textSubtle mb-6 leading-relaxed">
          Bauen is an independent eyewear house founded on the passion for design and precision.
          Each creation embodies the union of artisanal craftsmanship and contemporary innovation.
        </p>
        <p className="text-textSubtle leading-relaxed">
          Inspired by the codes of timeless luxury, our eyewear is designed for lovers of sober elegance and technical excellence.
          Our mission: to create unique, customizable and durable pieces, crafted between Paris and Los Angeles.
        </p>
      </div>
    </section>
  )
}
